import { ConfigType } from "../../abstract/Form";
import { EthnicityType } from "../../types";
import { enumToOptions } from "../../utils";

export const config: ConfigType = {
  right: [
    {
      label: "form.patientBackground",
      rows: [
        {
          fields: [
            {
              name: "name",
              label: "fields.name",
              type: "text",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "birth",
              label: "fields.birth",
              type: "month",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "height",
              label: "fields.height",
              type: "height",
              required: true,
            },
            {
              name: "weight",
              label: "fields.weight",
              type: "weight",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "ethnicity",
              label: "fields.ethnicity",
              type: "tag-select",
              required: true,
              placeholder: "form.placeholders.ethnicity",
              caption: "form.captions.ethnicity",
              options: enumToOptions(EthnicityType),
            },
          ],
        },
      ],
    },
    {
      label: "form.patientCurrentStatus",
      subsections: [
        {
          label: "form.amhAndFsh",
          rows: [
            {
              fields: [
                {
                  name: "amh.value",
                  label: 'fields["amh.value"]',
                  type: "float",
                  required: true,
                  adornment: "ng/ml",
                },
                {
                  name: "amh.date",
                  label: 'fields["amh.date"]',
                  type: "date",
                  required: true,
                },
              ],
            },
            {
              fields: [
                {
                  name: "fsh.value",
                  label: 'fields["fsh.value"]',
                  type: "float",
                  required: true,
                  adornment: "mIU/ml",
                },
                {
                  name: "fsh.date",
                  label: 'fields["fsh.date"]',
                  type: "date",
                  required: true,
                },
              ],
            },
          ],
        },
        {
          label: "form.afc",
          rows: [
            {
              fields: [
                {
                  name: "afc.left",
                  label: 'fields["afc.left"]',
                  type: "integer",
                  required: true,
                  adornment: "follicles",
                },
                {
                  name: "afc.right",
                  label: 'fields["afc.right"]',
                  type: "integer",
                  required: true,
                  adornment: "follicles",
                },
              ],
            },
            {
              fields: [
                {
                  name: "afc.date",
                  label: 'fields["afc.date"]',
                  type: "date",
                  required: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "form.cycleDetails",
      rows: [
        {
          fields: [
            {
              name: "retrieval.date",
              label: 'fields["retrieval.date"]',
              type: "date",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "retrieval.count",
              label: 'fields["retrieval.count"]',
              type: "integer",
              required: true,
            },
          ],
        },
      ],
    },
  ],
  left: [],
};
